import { createAction } from 'redux-actions'

export const getRecipeStarted = createAction('GET_RECIPE_STARTED')
export const getRecipeSuccess = createAction('GET_RECIPE_SUCCEED')
export const getRecipeFail = createAction('GET_RECIPE_FAILED')
